import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'productTypeTitle',
    standalone: true
})
export class ProductTypeTitlePipe implements PipeTransform {

	transform(isLoose: boolean): 'IS_LOOSE' | 'PACKED' {
		return isLoose ? 'IS_LOOSE' : 'PACKED';
	}

}
